const routes = [
  {
    path: '/elemempr',
    name: 'Elementos y Tarifario',
    component: () => import('@/views/forms/ElemEmpr.vue'),
    meta: { title: 'Elementos y Tarifario' }
  }
];

export { routes };
